<div *ngIf="classRef.userEmail" class="message-container">
  Confirm your email address. We sent an email to {{ classRef.userEmail }}. Check your email and click on the confirmation link to continue.
  <span *ngIf="classRef.count" class="count-down">
    {{ classRef.countDownTimer }}
  </span>
  <span *ngIf="classRef.showResendBtn" class="resend-btn" (click)="onResendClick()">
    Resend
  </span>
</div>
